type CustomerAuthErrorBannerProps = {
  error: string
  closeLabel: string
  onClose: () => void
}

export const CustomerAuthErrorBanner = ({
  error,
  closeLabel,
  onClose,
}: CustomerAuthErrorBannerProps) => {
  if (!error) return null

  return (
    <div
      className="ca-theme-transition mt-5 rounded-xl border border-(--color-status-error-border) bg-(--color-status-error-bg) px-4 py-3 text-sm text-(--color-status-error)"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-3">
        <span>{error}</span>
        <button
          type="button"
          className="ca-theme-transition rounded-full border border-(--color-status-error-border) px-2 py-1 text-xs font-semibold hover:bg-[color-mix(in_srgb,var(--color-status-error-bg)_75%,transparent)]"
          onClick={onClose}
        >
          {closeLabel}
        </button>
      </div>
    </div>
  )
}
